const INITIAL_STATE = {
  user: null,
  registered_users: null
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "USER_DATA":
      return { ...state, user: action.payload };
    case "USER_REGISTERED":
      return { ...state, registered_users: action.payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/user.js